import type { Ref } from "vue";
import type { NavigationGuard } from "vue-router";
import { whenFlagsReady } from "@/config/split/flagReadiness";

export const createFlagRouteGuard = (
  isFeatureAvailable: Ref<boolean>,
  fallbackName: string,
): NavigationGuard => {
  return async (to, _from, next) => {
    await whenFlagsReady();
    if (isFeatureAvailable.value) {
      next();
      return;
    }
    next({ name: fallbackName, params: to.params });
  };
};
